import { Button, Tooltip } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAppSelector } from '../../Reducers/store';
import { HiPencilAlt } from 'react-icons/hi';
import { Vendor } from '../../Models/Vendor';
import VendorApi from '../../Api/VendorApi';

export default function VendorProfile() {
  const { userModel } = useAppSelector((state) => state.user);
  const { id } = useParams();
  const [vendorData, setVendorData] = useState<Vendor | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getVendor = () => {
    if (id) {
      setIsLoading(true);
      VendorApi.getVendor(id)
        .then((res) => {
          setVendorData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setVendorData(null);
    }
  };

  useEffect(() => {
    getVendor();
  }, [id]);

  function checkAccess() {
    if (vendorData && userModel && id) {
      return true;
    }
    return false;
  }

  return (
    <div className='w-full'>
      <div className='w-full p-4'>
        <div className='mx-1 flex items-end'>
          <div className='flex flex-1'>
            <h1 className='text-gray-900 font-bold text-4xl'>
              Vendor Information
            </h1>
          </div>
          {checkAccess() && (
            <div className='right-2'>
              <Link to={`/vendor/edit/${vendorData?.id}`}>
                <Tooltip content='Edit'>
                  <Button className='buttonMain'>
                    <HiPencilAlt size={20} />
                  </Button>
                </Tooltip>
              </Link>
            </div>
          )}
        </div>
      </div>

      <div>
        <div className='container mx-auto p-2'>
          <div className='md:flex no-wrap md:-mx-2 '>
            <div className='w-full mx-2'>
              <div className='bg-white p-3'>
                <div className='flex items-center space-x-2 font-bold text-gray-500 leading-8 py-2'>
                  <span className='tracking-wide uppercase text-3xl'>
                    {vendorData?.name}
                  </span>
                </div>
                <hr className='bg-gray-200 h-[5px]'></hr>
                <div className='text-gray-500'>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Name:</div>
                    </div>
                    <div className='pl-1 text-black'>{vendorData?.name}</div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Account #:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {vendorData?.accountNumber}
                    </div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Email:</div>
                    </div>
                    <div className='pl-1 text-black'>{vendorData?.email}</div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Phone:</div>
                    </div>
                    <div className='pl-1 text-black'>{vendorData?.phone}</div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Address:</div>
                    </div>
                    <div className='flex flex-col'>
                      <div className='pl-1 text-black'>
                        {vendorData?.address}
                      </div>
                      <div className='w-full flex'>
                        <div className='pl-1 text-black'>
                          {vendorData?.city}
                          {vendorData?.city && ','}{' '}
                        </div>
                        <div className='pl-1 text-black'>
                          {vendorData?.stateId}{' '}
                        </div>
                        <div className='pl-1 text-black'>{vendorData?.zip}</div>
                      </div>
                    </div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Website:</div>
                    </div>
                    <div className='pl-1 text-black'>{vendorData?.website}</div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='font-bold content-center'>Description:</div>
                    <div>
                      <div className='pl-1 text-black'>
                        {vendorData?.description}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
